import { useChargePointsFetchingContext } from 'entities/charge-point/charge-points-layout';

import { ConnectedReservesTable } from '../../../widgets/session/reserve-sessions-table/ui/connected-table';

export function ChargePointsReservesPage() {
  const { handleSetFetchingTab } = useChargePointsFetchingContext();

  return <ConnectedReservesTable handleSetFetchingTab={handleSetFetchingTab} />;
}
